import { render, staticRenderFns } from "./resume-education.vue?vue&type=template&id=99ed6776&scoped=true"
import script from "./resume-education.vue?vue&type=script&lang=js"
export * from "./resume-education.vue?vue&type=script&lang=js"
import style0 from "./resume-education.vue?vue&type=style&index=0&id=99ed6776&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ed6776",
  null
  
)

export default component.exports